// import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

// const LoadingIndicator = ({ message = "Loading..." }) => {
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//         backgroundColor: "#f4f4f9",
//       }}
//     >
//       <CircularProgress
//         size={80}
//         sx={{ color: "#3498db", marginBottom: 2 }}
//       />
//       <Typography variant="h6" sx={{ color: "#2c3e50" }}>
//         {message}
//       </Typography>
//     </Box>
//   );
// };

// export default LoadingIndicator;


import { BounceLoader } from "react-spinners";

const LoadingIndicator = ({ message = "Loading..." }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f4f4f9",
      }}
    >
      <BounceLoader color="#f7c948" size={80}   />
      <Typography variant="h6" sx={{ color: "#2c3e50", marginTop: 2 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingIndicator;
